import { ReactComponentType } from 'strapi/component/types';
import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import { collectButtonComponentParams } from '../landingButton';
import { collectMediaElementParams } from '../shared/mediaElement';

import { Steps } from './Steps';
import { Step, StepsStrapiComponent } from './types';

export const collectStepsComponentParams = (
  data: StepsStrapiComponent,
  page: PageTypes
) => {
  const steps = data?.steps
    ?.map((x) => {
      const media = collectMediaElementParams({ media: x.media });

      return {
        media: media,
        title: x.title,
        description: x.description,
      };
    })
    .filter((x) => !!x.media && !!x.title) as Step[];

  return {
    steps: steps,
    title: data.title,
    button: collectButtonComponentParams(page, data.button),
    backgroundGradient: data.backgroundGradient,
  };
};

export const collectStepsParams = (
  _: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof Steps> | undefined => {
  if (!('steps' in page) || !page.steps) {
    return undefined;
  }

  const params = collectStepsComponentParams(page.steps, page);

  return {
    component: ReactComponentType.Steps,
    props: params,
  };
};
